<div  class="row">
    <div class="col-sm-12">
        <h1  class="text-center">{{quizEnvelop.studentName}}</h1>
        <h2 id="quizInfo" class="text-center">Quiz for {{quizEnvelop.subjectName}}:{{quizEnvelop.level_name}}</h2>
        <h3 id="quizDate" class="text-center">Date:{{quizEnvelop.datecreated}}</h3>
    </div>
</div>
<div class="row"  *ngIf="quizEnvelop.server_quiz_envelop_id!=0 && !loading">
    <div class="col-sm-12">
        <div  *ngIf="quizEnvelop.server_quiz_envelop_id!=0 && quizEnvelop.questions.length>0" class="table-responsive">
          <table class="table table-striped table-borderless">
            <tbody>
                <tr *ngFor="let question of  quizEnvelop.questions; index as myCount;">
                  <td id="myquestion_{{question.server_question_id}}" >
                    <app-admin-show-question
                    (renderMathRequest)="renderMathPage($event)"

                    [question]="question"
                    [learner] ="learner"
                    [myCount]="myCount"
                    [quizEnvelop]="quizEnvelop"> </app-admin-show-question>


                  </td>
                </tr>

            </tbody>
          </table>
       </div>

    <fieldset class="buttons text-center margin-50-top">
        <a [routerLink]="['/admin/envelop/quiz/index']" class="btn btn-primary me-2"> Back To Admin Envelops</a>
        <button *ngIf="!loading" class="btn btn-danger" (click)="deleteQuizEnvelop()"> Delete Quiz </button>
    </fieldset>

</div>
</div>
<app-spinner *ngIf="loading"></app-spinner>

